import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import Home from './pages/Home';
import About from './pages/About';
import Management from './pages/Management';
import Events from './pages/Events';
// import Results from './pages/Results';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Studentlife from './pages/Studentlife';
import Loader from './components/Loader';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { showLoader, hideLoader } from './redux/loaderSlice';

function AppContent() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showLoader());

    // Simulate loading time
    const timeout = setTimeout(() => {
      dispatch(hideLoader());
    }, 1000); // Adjust the delay as needed

    return () => clearTimeout(timeout);
  }, [location.pathname, dispatch]);

  return (
    <>  
      <Loader />
      <Navbar />
      <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route exact path="/home" element={<Home/>} />
          <Route exact path="/about-us" element={<About/>} />
          <Route exact path="/management" element={<Management/>} />
          <Route exact path="/events" element={<Events/>} />
          {/* <Route exact path="/results" element={<Results/>} /> */}
          <Route exact path="/life" element={<Studentlife/>} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
